import React from 'react'
import ReactModal from 'react-modal'

const CancelButton = ({ customCancelButton, handleCloseGenericModal }) => {
  if(customCancelButton){
    return customCancelButton
  }else{
    return <div>
      <button
        className='btn btn-danger-tertiary close-modal'
        onClick={handleCloseGenericModal}>
        Close
      </button>
    </div>
  }
}

const GenericPopUpModal = ({ content, customCancelButton, customClass, handleCloseGenericModal, includeChatButton, modalCalendarLink }) => {
  let newClass = customClass ? customClass : ''
  return(
    <div>
      <ReactModal
        className={'react-modal generic info-modal ' + newClass}
        onRequestClose={() => handleCloseGenericModal()}
        isOpen={true}
        appElement={document.querySelector('#root')}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        style={{ overlay: { background: 'rgba(60,59,59,0.75)' }}}>
        <div className='generic-info-modal-header'>
          <i className='fa fa-times-thin fa-2x' onClick={() => handleCloseGenericModal()}></i>
        </div>
        <div className="generic-info-modal-content">
          <div dangerouslySetInnerHTML={{ __html: content }}></div>
          <div className="button-container">
            {includeChatButton || customClass == 'troubleshooting' ?
              <div>
                <hr />
                <h6>
                  Need additional help?
                </h6>
                <button
                  className='eblue-button open-chat-window'
                  onClick={() => handleCloseGenericModal(true)}>
                  Open LiveChat
                </button>
              </div>
              : ''}
            { modalCalendarLink }
            <hr />
            <CancelButton customCancelButton={customCancelButton} handleCloseGenericModal={handleCloseGenericModal} />
          </div>
        </div>
      </ReactModal>
    </div>
  )
}

export default GenericPopUpModal


